import { render, staticRenderFns } from "./LikeCommentButton.vue?vue&type=template&id=760e0ee2&scoped=true"
import script from "./LikeCommentButton.vue?vue&type=script&lang=js"
export * from "./LikeCommentButton.vue?vue&type=script&lang=js"
import style0 from "./LikeCommentButton.vue?vue&type=style&index=0&id=760e0ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e0ee2",
  null
  
)

export default component.exports